const MEASUREMENT_ID = 'G-MHQG4D3MLB'
const ENABLE_IN_DEV = process.env.VUE_APP_GA_ENABLE_IN_DEV === 'true'

function isEnabled() {
  if (process.env.NODE_ENV === 'production') return true
  return ENABLE_IN_DEV
}

function isGtagLoaded() {
  return typeof window.gtag === 'function'
    && document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}"]`)
}

function loadGtagScript() {
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}"]`)) {
    return
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)
}

export function initGoogleAnalytics() {
  if (!isEnabled()) return

  // Production builds load gtag from public/index.html
  if (isGtagLoaded()) return

  loadGtagScript()

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }

  window.gtag('js', new Date())
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: false,
  })
}

export function trackPageView(path, title) {
  if (!isEnabled() || typeof window.gtag !== 'function') return

  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: `${window.location.origin}${path}`,
  })
}
